module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/UTWGeZ/tc-custom/9781623808822.jpg?1718183001158",
      "alt": "This image is the cover for the book De la A a la Z, La saga de la ciudad de Coda"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("De la A a la Z, La saga de la ciudad de Coda\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Un libro de La saga de la ciudad de Coda")])])]), _c('p', [_vm._v("Zach Mitchell está preso en la rutina. Su novio de la universidad lo dejó hace diez años, pero él aún vive en el mismo apartamento, conduce el mismo coche y alimenta al desagradecido gato de su ex novio. Su negocio en Denver, el videoclub De la A a la Z, está en apuros. Tiene clientes molestos, excéntricos vecinos, y un romance vacío con su casero, Tom.")]), _vm._v(" "), _c('p', [_vm._v("Angelo Green, es un tipo duro resentido que lleva botas de combate y se ha criado en casas de acogida. Está solo desde los dieciséis años, por eso nunca aprendió a confiar ni a querer a nadie. No tiene amigos, así que cuando consigue un trabajo en el videoclub De la A a la Z, decide que Zach está estrictamente prohibido.")]), _vm._v(" "), _c('p', [_vm._v("A pesar de sus diferencias, Zach y Angelo se hacen amigos rápidamente por lo que cuando Zach rompe con Tom y la estabilidad de su negocio se tambalea, es a Angelo a quien se le ocurre una solución. Junto a Jared y Matt, sus amigos de Coda, Colorado, Zach y Angelo encontrarán una forma de salvar De la A a la Z, ¿pero serán también capaces de salvarse el uno al otro?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marie Sexton, Cristina P. Pérez\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0